export default __webpack_public_path__ + "static/media/xamk_logo_laaja2_mv_rgb.4c87e237.png";